module.exports = __webpack_public_path__ + "static/media/ico_explore.cb97e95a.svg";